import React, { useState } from 'react';
import { Icon, Drawer, Loading, Wrapper } from '@/components';
import Header from './header';
import FileStack from './file-stack';
import styles from './style.less';
import { i18n, createObjectURL, getBlobUrl } from '@/utils';
import { ZuploaderOutputImage } from './zuploader';
export { default as ZuploaderImageList, ZuploaderImageListHandle } from './image-list';
export { default as ZuploaderChooseImage } from './choose-image';

interface ZuploaderProps {
  /** 标题下的额外元素 */
  titleExtra?: React.ReactNode;
  /** 是否支持多选 */
  multiple?: boolean;
  /** ga对象 */
  gtag?: any;
  /** 关闭回调 */
  onClose(): void;
  /** 确认回调 */
  onConfirm(ouput: string[]): void;
}

const Zuploader: React.SFC<ZuploaderProps> = ({ multiple, titleExtra, gtag = () => {}, onClose, onConfirm }) => {

  // 图片管理显隐
  const [ fileStackVisible, setFileStackVisible ] = useState(false);
  const [ loading, setLoading ] = useState<boolean>(false);

  /** 本地相册变化监听 */
  const handleaAlbumChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    gtag('event', 'event_tap_album');
    const files = event.target.files || [];
    onConfirm(Array.from({ length: files.length || 0 })
      .map((_, index) => createObjectURL(files[index])));
  }

  /** 本地相机变化监听 */
  const handleCameraChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    gtag('event', 'event_tap_camera');
    const files = event.target.files || [];
    onConfirm(Array.from({ length: files.length || 0 })
      .map((_, index) => createObjectURL(files[index])));
  }

  /** fileStack确认 */
  const handleFileStackConfirm = async (ouput: ZuploaderOutputImage[]) => {
    setLoading(true);
    const images = await Promise.all(ouput.map(item => getBlobUrl(item.image)));
    onConfirm(images);
    setLoading(false);
  }

  /** 唤醒fileStack */
  const handleFileStackChange = () => {
    gtag('event', 'event_tap_social');
    setFileStackVisible(true)
  }

  return (
    <div className={styles.zuploader}>
      <Drawer
        className={styles.source}
        onClose={onClose}
      >
        <Header
          title={i18n.format('plugin.zuploader.choose.source')}
          extra={titleExtra}
          onClose={onClose}
        />
        <div className={styles.sourceContent}>
          <div className={styles.contentGroup}>
            <div className={styles.contentGroupLocal}>
              <span>{i18n.format('plugin.zuploader.from.album')}</span>
              <Icon type="photo" size={30} />
              <input type="file" accept="image/*" multiple={multiple} onChange={handleaAlbumChange} />
            </div>
            <div className={styles.contentGroupLocal}>
              <span>{i18n.format('plugin.zuploader.from.camera')}</span>
              <Icon type="camera" size={30} />
              <input type="file" accept="image/*" capture="camera" onChange={handleCameraChange} />
            </div>
          </div>
          <div
            className={styles.contentGroup}
            onClick={handleFileStackChange}
          >
            <div className={styles.contentGroupSocial}>
              <div className={styles.logos}>
                <img src={require('./social-icon/facebook.png')} />
                <img src={require('./social-icon/instagram.png')} />
                <img src={require('./social-icon/google-driver.png')} />
              </div>
              <span>{i18n.format('plugin.zuploader.from.social')}</span>
            </div>
          </div>
        </div>
        <div
          className={styles.sourceFooter}
          onClick={onClose}
        >
          <span>{i18n.format('modules.global.cancel')}</span>
        </div>
      </Drawer>
      {fileStackVisible &&
        <FileStack
          multiple={multiple}
          onClose={() => setFileStackVisible(false)}
          onConfirm={handleFileStackConfirm}
        />
      }
      {loading &&
        <Wrapper className={styles.loadingWrapper}>
          <Loading />
        </Wrapper>
      }
    </div>
  );
}

export default Zuploader;
